import { render } from "./CIS-CTA-Secondary.vue?vue&type=template&id=4be5d762"
import script from "./CIS-CTA-Secondary.vue?vue&type=script&lang=js"
export * from "./CIS-CTA-Secondary.vue?vue&type=script&lang=js"

import "./CIS-CTA-Secondary.vue?vue&type=style&index=0&id=4be5d762&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__